import { makeAutoObservable } from 'mobx';

import { GroupStatus, USER_TEXT, UserType } from '../constants';
import { GroupDto } from '../dto';

export class GroupModel {
  private _id: number;
  private _status: GroupStatus;
  private _title: string;
  private _type: UserType;
  private _at: string;
  private _venueId: number;
  private _unread: boolean;
  private _summary?: string;

  constructor(data?: GroupDto) {
    this._id = data?.id || -1;
    this._status = data?.status || GroupStatus.WAITING;
    this._title = data?.title || '새로운 문의/답변';
    this._type = data?.type || UserType.MANAGER;
    this._at = data?.at || new Date().toISOString();
    this._venueId = data?.venueId || -1;
    this._unread = data?.unread || false;
    this._summary = data?.summary;
    makeAutoObservable(this);
  }
  toJSON() {
    return {
      id: this.id,
      title: this.title,
      status: this.status,
      type: this.type,
      at: this.at,
      venueId: this.venueId,
      unread: this.unread,
      summary: this.summary,
    };
  }

  static fromJSON(json: any): GroupModel {
    return new GroupModel(json);
  }
  get id() {
    return this._id || -1;
  }
  get status() {
    return this._status;
  }
  set status(value) {
    this._status = value;
  }
  get title() {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
  }
  get type() {
    return this._type;
  }
  get typeText() {
    switch (this._type) {
      case UserType.CLIENT:
        return `${USER_TEXT[this._type]}`;
      case UserType.MANAGER:
        return `${USER_TEXT[this._type]}`;
    }
  }
  get at() {
    return this._at;
  }
  get venueId() {
    return this._venueId;
  }
  get unread() {
    return this._unread;
  }
  set unread(value: boolean) {
    this._unread = value;
  }
  get summary() {
    return this._summary;
  }
}
